import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { ChevronLeft, ShieldCheck } from "lucide-react";

export default function CGU() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-slate-950" data-testid="cgu-page">
      <div className="mx-auto max-w-2xl px-5 py-10">
        <Button variant="ghost" size="sm" className="mb-6 rounded-full text-sky-200 hover:bg-white/10" onClick={() => navigate(-1)} data-testid="cgu-back-btn">
          <ChevronLeft size={16} className="mr-1.5" /> {t("cgu.ui.back")}
        </Button>

        <div className="mb-8 text-center">
          <div className="mb-3 inline-flex items-center gap-2 rounded-full border border-sky-400/30 bg-sky-500/10 px-3 py-1 text-xs font-medium text-sky-200">
            <ShieldCheck size={13} /> POSTINITY
          </div>
          <h1 className="text-3xl font-bold text-white">{t("cgu.ui.title")}</h1>
          <p className="mt-2 text-sm text-white/60">{t("cgu.ui.updated")}</p>
        </div>

        <div className="space-y-6" data-testid="cgu-content">
          {/* Articles retirés — nouvelles CGU à venir (emplacement différent) */}
        </div>

        <div className="mt-10 text-center">
          <Button className="rounded-full bg-sky-500 text-black hover:bg-sky-400" onClick={() => navigate(-1)} data-testid="cgu-close-btn">
            {t("cgu.ui.close")}
          </Button>
        </div>
      </div>
    </div>
  );
}
